export default function initScrollOffsetLinks() {
  const links = document.querySelectorAll('a[data-scroll-offset][href^="#"]')

  links.forEach((link) => {
    link.addEventListener("click", (event) => {
      const hash = link.getAttribute("href")
      if (!hash || hash === "#") return

      const target = document.querySelector(hash)
      if (!target) return

      event.preventDefault()

      const top = target.getBoundingClientRect().top + window.scrollY

      window.scrollTo({ top, left: 0, behavior: "smooth" })

      if (history.pushState) {
        history.pushState(null, "", hash)
      }
    })
  })
}
